import { RouterConfig } from "@shared/lib/routerConfig";
import { AuctionIcon } from "@shared/ui/Icon/ui/Navigation/AuctionIcon";
import { AutoIcon } from "@shared/ui/Icon/ui/Navigation/AutoIcon";
import { BlogIcon } from "@shared/ui/Icon/ui/Navigation/BlogIcon";
import { ContactsIcon } from "@shared/ui/Icon/ui/Navigation/ContactsIcon";
import { DocumentsIcon } from "@shared/ui/Icon/ui/Navigation/DocumentsIcon";
import { EstimateIcon } from "@shared/ui/Icon/ui/Navigation/EstimateIcon";
import { HomeIcon } from "@shared/ui/Icon/ui/Navigation/HomeIcon";
import { InsuranceIcon } from "@shared/ui/Icon/ui/Navigation/InsuranceIcon";
import { SettingsIcon } from "@shared/ui/Icon/ui/Navigation/SettingsIcon";

export const mobileMenuItems = [
    { title: "Главная", link: RouterConfig.MAIN, Icon: HomeIcon },
    { title: "Автомобили", link: RouterConfig.CATALOG, Icon: AutoIcon },
    { title: "Страхование", link: RouterConfig.INSURANCE, Icon: InsuranceIcon },
    { title: "Оценка авто", link: RouterConfig.ANALYTICS, Icon: EstimateIcon },
    { title: "Документы", link: RouterConfig.GENERATOR_DKP, Icon: DocumentsIcon },
    {
        title: "Обслуживание авто",
        link: "https://new-service.uremont.com",
        Icon: SettingsIcon,
        external: true
    },
    { title: "Аукцион", link: "https://www.migtorg.com", Icon: AuctionIcon, external: true },
    { title: "Блог", link: RouterConfig.BLOG, Icon: BlogIcon },
    { title: "Общие контакты", link: RouterConfig.CONTACTS, Icon: ContactsIcon }
];